//libraries
import React from 'react'
import clsx from 'clsx'

// components
import Section from '/react4xp/components/Section'
import RichText from '/react4xp/components/RichText'
import Image from '/react4xp/components/Image'
import Link from '/react4xp/components/Link'

// svg
import { UxArrowRight } from '/react4xp/components/Svg/Ux/Arrow'
import Sparkle from '/react4xp/components/Svg/Others/Sparkle'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// prop types
export interface ShareYourIdeaProps {
    section: {
        bgColor: 'white' | 'white-dark' | 'red' | string
        paddingTop?: 'smaller' | 'small' | 'medium' | 'big' | 'none'
        paddingBottom?: 'smaller' | 'small' | 'medium' | 'big' | 'none'
    }
    box: {
        small?: boolean
        image?: string
        alt?: string
        title?: string
        content?: string
        animatedCta?: boolean
        cta?: {
            text: string
            href: string
            external?: boolean
        }
    }
    
    className?: string
}

export default function ShareYourIdea({
    section,
    box,
    className
}: ShareYourIdeaProps) {
    return (
        <Section
            bgColor={
                clsx(
                    section.bgColor === 'white' && 'white',
                    section.bgColor === 'white-dark' && 'white-dark',
                    section.bgColor === 'red' && 'red',
                    !['red', 'white', 'white-dark'].includes(section.bgColor) && section.bgColor
                )
            }
            className={clsx('share-your-idea', className)}
            paddingTop={section.paddingTop}
            paddingBottom={section.paddingBottom}
        >
            <div className='container relative z2'>
                <div className='row'>
                    <div className={clsx(box.small ? 'col-md-10 offset-md-1' : 'col-12')}>

                        <div
                            className={clsx(
                                'share-your-idea__box',
                                section.bgColor === 'white' && 'bg-red white',
                                (section.bgColor === 'red' || section.bgColor === 'white-dark') && 'bg-white blue',
                                !['red', 'white', 'white-dark'].includes(section.bgColor) && 'bg-white blue'
                            )}
                        >

                            {box.image && (
                                <Image
                                    src={box.image}
                                    alt={box.alt}
                                    className='logo'
                                />
                            )}

                            {isNonWhitespaceString(box.title) && (
                                <h2 className='h2'>{box.title}</h2>
                            )}

                            {isNonWhitespaceString(box.content) && (
                                <RichText className='text-big' content={box.content} />
                            )}

                            {isNonWhitespaceString(box.cta?.text) && isNonWhitespaceString(box.cta?.href) && (
                                box.animatedCta ? (
                                    <a
                                        href={box.cta.href}
                                        target={!!box.cta.external ? '_blank' : '_self'}
                                        className={clsx(
                                            'animated-cta',
                                            section.bgColor === 'white' && 'white',
                                            (section.bgColor === 'white-dark' || section.bgColor === 'red') && 'red-bg',
                                            !['red', 'white', 'white-dark'].includes(section.bgColor) && 'red-bg'
                                        )}
                                    >

                                        <Sparkle />

                                        <span className='button button-has-borders text-small hover-bg-blue-dark relative z2'>
                                            <span>
                                                {box.cta.text}
                                            </span>
                                        </span>
                                    </a>
                                ) : (
                                    <Link
                                        text={box.cta.text}
                                        href={box.cta.href}
                                        target={!!box.cta.external}
                                        iconPosition='right'
                                        icon={<UxArrowRight />}
                                        noMotionMobile
                                    />
                                )
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </Section>
    )
}